import { createSlice } from "@reduxjs/toolkit";

const globalSlice = createSlice({
  name: "global",
  initialState: {
    changePasswordModal: false,
    addModal: false,
    updateModal: false,
    updateId: null,
    detailsModal: false,
    detailsId: null,
    scheduleMaintenanceModal: false,
    scheduleMaintenanceComponent: null,
    objectMaintenanceModal: false,
    objectMaintenanceData: null,
    feedbackModal: false,
    feedbackData: null,
    bool: false,
    filter: false,
  },
  reducers: {
    toggleChangePasswordModal: (state) => {
      state.changePasswordModal = !state.changePasswordModal;
    },
    toggleAddModal: (state) => {
      state.addModal = !state.addModal;  // Toggle show state
    },
    toggleUpdateModal: (state, action) => {
      state.updateId = action?.payload?.id
      state.updateModal = !state.updateModal;  // Toggle show state
    },
    toggleBool: (state) => {
      state.bool = !state.bool;  // Toggle bool state
    },
    toggleFilter: (state) => {
      state.filter = !state.filter;  // Toggle bool state
    },
    toggleDetailsModal: (state, action) => {
      state.detailsId = action?.payload?.id
      state.detailsModal = !state.detailsModal;  // Toggle show state
    },
    toggleScheduleMaintenanceModal: (state, action) => {
      state.scheduleMaintenanceComponent = action?.payload?.component || null
      state.scheduleMaintenanceModal = !state.scheduleMaintenanceModal;  // Toggle show state
    },
    toggleObjectMaintenanceModal: (state, action) => {
      state.objectMaintenanceData = action?.payload?.data || null
      state.objectMaintenanceModal = !state.objectMaintenanceModal;  // Toggle show state
    },
    toggleFeedbackModal: (state, action) => {
      state.feedbackData = action?.payload?.data || null
      state.feedbackModal = !state.feedbackModal;  // Toggle show state
    },
  },
});

// Export actions
export const { toggleChangePasswordModal, toggleAddModal, toggleUpdateModal, toggleBool, toggleFilter, toggleDetailsModal, toggleScheduleMaintenanceModal, toggleObjectMaintenanceModal, toggleFeedbackModal } = globalSlice.actions;

// Export reducer
export default globalSlice.reducer;